import React, { useEffect, useState, useCallback } from 'react';
import {
  Switch,
  useHistory,
  useLocation,
  useRouteMatch,
} from 'react-router-dom';
import { useRootRoute, Authorize, AuthorizedRoute } from '@erecruit/modules';
import { Intl } from '@erecruit/core';
import { Button, Flex, Icon } from '@erecruit/ui-kit';
import { AppPermissions } from '@erecruit/types';

import Insight from '../App/components/InsightPortal';
import PositionRecord from '../components/PositionRecord';
import PositionSearch from '../components/PositionSearch/PositionSearch';

const AddNewPositionAction = () => {
  const history = useHistory();

  const onAddNewShiftClick = useCallback(() => {
    history.push('/requestPosition', {
      reset: true,
    });
  }, [history]);

  return (
    <Button type="primary" onClick={onAddNewShiftClick}>
      <Flex align="center">
        <Intl.FormattedMessage
          id={messageIds.vms.positionSearch.addNewPosition}
        />
        <Icon type="plus" size="small" color="bodyTertiary" />
      </Flex>
    </Button>
  );
};

const customPositionSearchActions = [
  <Authorize key="addPosition" permission={AppPermissions.AddNewPosition}>
    <AddNewPositionAction />
  </Authorize>,
];

const Positions = () => {
  const [isMountedHistory, setIsMountedRouter] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();
  const rootRoute = useRootRoute();
  const routeMatch = useRouteMatch<{ positionId: string }>();

  if (!isMountedHistory && !routeMatch.isExact) {
    history.push(pathname.replace('positions', 'position'));
  }
  useEffect(() => {
    return history.listen(() => {
      setIsMountedRouter(true);
    });
  }, [history]);

  return (
    <>
      <PositionSearch
        exportPermission={AppPermissions.ExportPositions}
        actions={customPositionSearchActions}
      />
      {isMountedHistory && (
        <Switch>
          <AuthorizedRoute
            permission={`${AppPermissions.ViewPositions} & ${AppPermissions.ViewPosition}`}
            path={`/positions/:id/:matchStatus?`}
            render={props => (
              <Insight referer={rootRoute}>
                <PositionRecord {...props} />
              </Insight>
            )}
          />
        </Switch>
      )}
    </>
  );
};

export default Positions;
